export function removeEntities(entities, field, values) {
    if (values === undefined) {
        return entities;
    }
    var idsToRemove = entities.valueSeq()
        .filter(function (m) { return values.indexOf(m.get(field)) !== -1; })
        .map(function (m) { return m.get('id'); })
        .toArray();
    entities = entities.withMutations(function (e) {
        for (var j = 0; j < idsToRemove.length; j++) {
            var id = idsToRemove[j];
            e.delete(id);
        }
    });
    return entities;
}
export function myRemoveEntities(entities, field, values) {
    if (values === undefined) {
        return entities;
    }
    if (entities.size <= 0) {
        return entities;
    }
    var idsToRemove = values.map(function (v) { return v.id; });
    entities = entities.filter(function (e) {
        var fieldValue = Number(e.get(field));
        return (idsToRemove.indexOf(fieldValue) == -1);
    });
    return entities;
}
export function myRemoveEntitiesBySport(entities, field, values) {
    if (values === undefined) {
        return entities;
    }
    if (entities.size <= 0) {
        return entities;
    }
    entities = entities.filter(function (e) {
        var fieldValue = Number(e.get(field));
        return (values.indexOf(fieldValue) == -1);
    });
    return entities;
}



// WEBPACK FOOTER //
// ./src/reducers/entities/utils.js